interface Props {
  score: number;
  type: "celebrate" | "support";
  style?: React.CSSProperties;
}

const SupportOrCelebrateDot = ({
  score,
  type,
  style = {},
}: Readonly<Props>) => {
  const getDotClassName = () => {
    if (score <= 2) {
      return "lowest";
    } else if (score <= 4) {
      return "low";
    } else if (score <= 6) {
      return "medium";
    } else if (score <= 8) {
      return "high";
    } else {
      return "highest";
    }
  };

  return (
    <div
      className={`support-celebrate-dot ${getDotClassName()} ${type}`}
      style={style}
    />
  );
};

export default SupportOrCelebrateDot;
